import { schema } from 'normalizr';

export const concernCategorySchema = new schema.Entity('concernCategory', {}, { idAttribute: '_id' });
export const concernCategoryListSchema = [concernCategorySchema];
